module.exports = __webpack_public_path__ + "static/img/5.25a060f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/5.png
// module id = rd4Z
// module chunks = 0